<template>
    <el-dialog class="privacy-dialog" :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :show-close="false"
        width="640px"
        title="温馨提示"
        center>
        <div class="privacy-dialog__paragraph privacy-dialog__paragraph--bold">
            感谢您信任并使用好分数辅导，为了能够更加全面保障您的权益，请务必仔细阅读最新版《好分数辅导用户协议》、《好分数辅导隐私政策》和《儿童隐私政策》。
        </div>
        <div class="privacy-dialog__paragraph privacy-dialog__paragraph--bold">
            在此特别提醒您，在点击接受本声明之前，您应该先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅并接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。
        </div>
        <div class="privacy-dialog__footer">
            <span class="privacy-dialog__hint">点击此处阅读
                <router-link class="privacy-dialog__link" :to="{name:'user-agreement'}" target="_blank">《好分数辅导用户协议》、</router-link>
                <router-link class="privacy-dialog__link" :to="{name:'privacy-agreement'}" target="_blank">《好分数辅导隐私政策》</router-link>和
                <router-link class="privacy-dialog__link" :to="{name:'child-privary-policy'}" target="_blank">《儿童隐私政策》</router-link>
            全文</span>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleAgree" class="dialog-btn-common btn-sure">我知道了</el-button>
        </span>
    </el-dialog>
</template>

<script>
const AGREE_EVENT_NAME = 'v3.6.2-PrivacyDialog-Agreed';
export default {
    data() {
        return {
            visible: true
        };
    },
    methods: {
        handleAgree() {
            this.visible = false;
            localStorage.setItem(AGREE_EVENT_NAME, '1');
        },
        showDialog() {
            const isAgreed = localStorage.getItem(AGREE_EVENT_NAME) === '1';
            this.visible = !isAgreed;
        }
    },
    beforeMount() {
        this.showDialog();
    }
};
</script>

<style lang="scss" scoped>
.privacy-dialog {
    /deep/ {
        .el-dialog__title {
            font-family: PingFangSC-Medium;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }

        .el-dialog__body {
            padding: 10px 20px 20px;
        }
    }

    &__header {
        font-family: PingFangSC-Medium;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 26px;
    }

    &__time {
        margin-right: 30px;
    }

    &__paragraph {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #4A4A4A;
        letter-spacing: 0;
        line-height: 26px;
        margin-bottom: 10px;

        &--bold {
            font-family: PingFangSC-Medium;
            font-weight: bold;
            color: #333333;
            line-height: 20px;
        }
    }

    &__hint {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #939393;
    }

    &__link {
        color: #FF4D2B;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    &__footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/PrivacyDialog.vue